module.exports = __webpack_public_path__ + "img/full3-min.813e95c5.png";